<template>
  <div class="popup-form">
  
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Vyberte hypotekára</div>
        <button
          class="w-button"
          @click="assignBrokerToClient()"
        >
          Priradiť
        </button>
      </div>

      <div
        class="popup-block pointer"
        v-for="(broker, key) in brokers"
        :key="key"
        @click="selectBroker(broker.id)"
      >
        <div class="vertical-align-divs flex-row">
          <div class="user-relation">
            <div>
              <img v-if="brokerId === broker.id"
                class="nav-link-icon filter-primary"
                style="margin-right: 10px;"
                src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f25_icons8-check.svg"
                alt="">
              <img
                v-if="broker.profile_image"
                :src="broker.profile_image"
                loading="lazy"
                sizes="100vw"
                alt=""
                class="broker-image"
              />
              <img
                v-else
                src="@/images/Michal-Voronič.jpg"
                loading="lazy"
                sizes="100vw"
                alt=""
                class="broker-image"
              />
            </div>
            <div class="text-block">
              <div class="text--black">
                {{ broker.first_name }} {{ broker.last_name }}
              </div>
              <div v-if="broker.staff_profile" @click.stop="openEditBrokerStaffProfile(broker)">Editovať</div>
            </div>
          </div>
          <div class="cta-text">{{ broker.aktivne_hypoteky_financnika }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imagesConvert from "../../../../../mixins/imagesConvert";
import {mapGetters} from "vuex";

export default {
  name: "BrokerPickerPopUp",
  props: {
    type: Object,
    payload: [Object, null],
  },
  mixins: [
    imagesConvert,
  ],

  computed: {
    ...mapGetters({
      refreshGetter: "popupManagerState/getUserManagerRefresh",
      popupSuccessResult: "popupManagerState/getPopupSuccessResult",

      getFormByType: "formStore/getFormByType",

      typeByClientFlow: "clientState/getTypeByClientFlow",
      typeByClientProfile: "clientState/getTypeByClientProfile",

      brokers: "clientState/getFinancnici"
    }),

    clientType1() {
      const clientFlow = this.clientData.client_profile.client_flow_status.flow.key;
      return this.typeByClientFlow(clientFlow);
    },
  },

  mounted () {
    this.brokerId = this.payload.financnik;
  },
  methods: {
    openEditBrokerStaffProfile(broker) {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: broker,
        component: "BrokerStaffProfilePopUp",
        rules: ['single'],
      });
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    async assignBrokerToClient () {
      this.$store.commit("appState/setLoadingPage", true);
      if (this.type.mortgage) {
        await this.assignBrokerWhileMortgage();
      } else {
        await this.assignBroker();
      }
      this.$store.dispatch("clientState/updateEmployees", ["financnik"]);
      this.$store.commit("popupManagerState/setUserManagerRefresh", true);
      this.$store.commit("appState/setLoadingPage", false);
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
      this.$store.commit("appState/setSuccessMessage", {
        text: "úspešne ste priradili ku klientovi bankára",
        type: "success"
      });
    },
    async assignBroker () {
      const type = this.$store.getters["clientState/getTypeByClientId"](this.payload.id);
      const client = {
        type,
        id: this.payload.id,
        client: {
          financnik: this.brokerId,
        }
      };
      await this.$store.dispatch("clientState/patchClient", client);
    },
    async assignBrokerWhileMortgage () {
      await this.assignBroker();
      await this.$store.dispatch("mortgagesState/fetchMortgage", {
        id: this.type.mortgageId,
        stage: this.type.mortgageStage
      });
    },
    selectBroker (id) {
      if (this.brokerId === id) {
        this.brokerId = null;
        return;
      }
      this.brokerId = id;
    },
  },
  data: () => ({
    brokerId: null
  }),
};
</script>

<style scoped lang="scss">
.selected-broker {
  border-style: none none none solid;
  border-color: #0a1953 #0a1953 #0a1953 #0019d9;
  border-left-width: 10px;
}

.popup-block:hover {
  cursor: pointer;
}

.popup {
  position: absolute !important;
  top: 0;
  z-index: 999;
  overflow-y: auto;
  transition-duration: 0.5s;
}
</style>
